var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"mb-1 drag-drawflow",staticStyle:{"cursor":"pointer"},attrs:{"color":_vm.iconColor,"draggable":"","title":_vm.title,"data-node":_vm.type},on:{"dragstart":_vm.dragstart}},[_vm._v(_vm._s(_vm.icon))])}
var staticRenderFns = []

export { render, staticRenderFns }